import { render, staticRenderFns } from "./MessageCenterModal.vue?vue&type=template&id=6ca07b6d&scoped=true&"
import script from "./MessageCenterModal.vue?vue&type=script&lang=js&"
export * from "./MessageCenterModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageCenterModal.vue?vue&type=style&index=0&id=6ca07b6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca07b6d",
  null
  
)

component.options.__file = "MessageCenterModal.vue"
export default component.exports